/**
 * Lazily load the Sentry React SDK via dynamic import.
 *
 * Used by error boundaries to report unexpected runtime errors without eagerly bundling Sentry.
 * Extracted into a helper to simplify testing of failure and offline scenarios.
 *
 * @returns A promise resolving to the `@sentry/react` module.
 */
export async function lazyLoadSentry() {
  return import('@sentry/react');
}